import { render, staticRenderFns } from "./Produto.vue?vue&type=template&id=04c72b28"
import script from "./Produto.vue?vue&type=script&lang=js"
export * from "./Produto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports